function loader_on(){
    $('.site > .preloader').fadeIn(400);
}

function loader_off(){
    $('.site > .preloader').fadeOut(400);
}

function cart_widget(){
    jQuery.post('/wp-admin/admin-ajax.php', {
        action: 'cart_widget'
    },
    function (res) {

        var $json = JSON.parse( res ),
            count = $json.count_product,
            price = $json.total_price_all;
        

        if(!count){
            count = 0;
            price = 0;
        }
        
        $('.header-cart .count, .mobile-cart .count, .top-btns .count, .mobile-cart-popup-content .count, .mobile-links .count').text(count);
        $('.top-header .cart .value span').text(price);

        if($('body').hasClass('page-template-cart')){
                var delivery = parseInt($('#address').attr('data-price')),
                    calc     = price + delivery;

            $('.cart-total-products').text(count);
            $('.cart-total-price').text(price);
            $('.cart-info-total-price').text(calc);
            $('.cart-delivery-price').text(delivery);
            $('.ymaps-2-1-76-balloon-content__header span').text(delivery);
        }

        if(count == 0){
            $('.header-cart .value').addClass('empty');
        }else{
            $('.header-cart .value').removeClass('empty');
        }

        var cart_text = count + ' ';

        if(count == 1){
            cart_text += 'товар на: ';
        }else if(count > 1 && count < 5){
            cart_text += 'товара на: ';
        }else{
            cart_text += 'товаров на: ';
        }

        cart_text += price + ' тг.';

        $('.header-cart .value span').text(cart_text);

        if(price >= 5000){
            $('.progress-block').addClass('success');
            $('.progress-block h5').text('Оформление заказа');
            $('.cart-progress span').text(price);
            $('.cart-form-btn').removeAttr('disabled').text('Оформить заказ');
        }else{
            $('.progress-block').removeClass('success');
            $('.progress-block h5').text('До суммы минимального заказа осталось:');
            $('.cart-progress span').text(5000 - price);
            $('.cart-form-btn').attr('disabled', 'disabled').text('Минимальная сумма 5000 тг.');
        }
        
    });
    
}

function sendAjax(name, data, success, error){
    jQuery.post('/wp-admin/admin-ajax.php', {
        action: name,
        data: data
    },
        function (res) {
            loader_off();

            try {
                JSON.parse(res);
            } catch (e) {
                $('.error-code').html($.trim(res));
                $('.error-popup').fadeIn(400);
                $('.error-popup').addClass('show');
                return false;
            }

            var json = JSON.parse(res);
            
            if(json.result == 'success'){                        
                success(json);                
            }else if(json.result == 'error' && error){
                error(json);
            }else{
                $('.error-code').html($.trim(res));
                $('.error-popup').fadeIn(400);
                $('.error-popup').addClass('show');
            }
        }
    );
}

function showNotice(notice, title, text, status){
    var n_title = notice.find('h5'),
        n_text  = notice.find('p');

    n_title.text(title);
    n_text.text(text);

    if(status){
        notice.addClass(status);
    }else{
        notice.addClass('success');
    }

    notice.slideDown(300);

    var offset = notice.offset().top - 80;
    $('html, body').animate({ 
        scrollTop: offset
    }, 400); 

    notice.find('.close-notice').click(function(){
        notice.slideUp(300);
    })

}